/**
 * 目前只支持在 window、document 和 document.body 下挂载 DOM 事件
 */
export var EventTarget = /*#__PURE__*/function (EventTarget) {
  EventTarget[EventTarget["WINDOW"] = 0] = "WINDOW";
  EventTarget[EventTarget["DOCUMENT"] = 1] = "DOCUMENT";
  EventTarget[EventTarget["DOCUMENT_BODY"] = 2] = "DOCUMENT_BODY";
  return EventTarget;
}({});

/**
 * 目前支持插件挂载的事件种类
 */
export var EventType = /*#__PURE__*/function (EventType) {
  EventType["RESIZE"] = "resize";
  EventType["MOUSE_DOWN"] = "mousedown";
  EventType["MOUSE_MOVE"] = "mousemove";
  EventType["MOUSE_UP"] = "mouseup";
  EventType["KEY_UP"] = "keyup";
  EventType["KEY_DOWN"] = "keydown";
  EventType["CLICK"] = "click";
  EventType["TOUCH_START"] = "touchstart";
  EventType["TOUCH_MOVE"] = "touchmove";
  EventType["TOUCH_END"] = "touchend";
  EventType["POP_STATE"] = "popState";
  EventType["VISIBILITY_CHANGE"] = "visibilitychange";
  EventType["ONLINE"] = "online";
  EventType["OFFLINE"] = "offline";
  EventType["MESSAGE"] = "message";
  EventType["CUSTOM"] = "custom";
  return EventType;
}({});
//# sourceMappingURL=event-listener.js.map